import { NgModule } from '@angular/core';
import { BrowserModule, HammerModule, Title } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { D7Module } from './d7/d7.module';
import { MaterialModule } from '../material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { UnderMaintenanceComponent } from './pages/under-maintenance/under-maintenance.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MfgComponent } from './main/hao/pages/mfg/mfg.component';
import { ListComponent as HaoComponent } from './main/hao/pages/list/list.component';
import { WelcomeComponent } from './main/educacao/pages/welcome/welcome.component';
import { ProfileComponent } from './main/configuracao/pages/profile/profile.component';
import { PipePaginationComponent } from './main/pipe-pagination/pipe-pagination.component';
import { ListComponent as HeadhunterListComponent } from './main/headhunter/pages/list/list.component';
import { DialogFilterComponent } from './main/headhunter/components/dialog-filter/dialog-filter.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MdePopoverModule } from '@material-extended/mde';
import { ListPhhComponent } from './main/favorite/pages/list-phh/list-phh.component';
import { ListHaoComponent } from './main/favorite/pages/list-hao/list-hao.component';
import { WebAdminComponent } from './main/web-admin/web-admin.component';
import { LineChartComponent } from './main/metrics/components/line-chart/line-chart.component';
import { LoginComponent } from './main/metrics/pages/login/login.component';
import { ChartsModule } from 'ng2-charts';
import { SharedComponent } from './main/consultor/pages/shared/shared.component';
import { ConsultorComponent } from './main/web-admin/components/consultor/consultor.component';
import { SyncDbComponent } from './main/web-admin/components/sync-db/sync-db.component';

@NgModule({
  declarations: [
    AppComponent,
    NotFoundComponent,
    UnderMaintenanceComponent,
    HaoComponent,
    MfgComponent,
    WelcomeComponent,
    ProfileComponent,
    PipePaginationComponent,
    ListHaoComponent,
    HeadhunterListComponent,
    DialogFilterComponent,
    ListPhhComponent,
    WebAdminComponent,
    LineChartComponent,
    LoginComponent,
    SharedComponent,
    ConsultorComponent,
    SyncDbComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    D7Module,
    AppRoutingModule,
    HammerModule,
    MaterialModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    FormsModule,
    NgSelectModule,
    MdePopoverModule,
    ChartsModule,
  ],
  exports: [],
  providers: [ Title ],
  bootstrap: [ AppComponent ],
})
export class AppModule {
}
